<template>
    <ContentWrapper>
    <div>
      <div class="content-heading">
      <div>계기자료</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
        <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">전시관리</li>
        <li class="breadcrumb-item active">
            <a href="/exhibit/instrumentData">계기자료</a>
        </li>
      </ol>
      </div>
      <div class="instrument-list justify-content-around" v-show="dataObj.params.mode=='list'">
        <div class="instrument-calendar float-left card card-default" style="width:350px;background-color:#fff;">
          <b-button @click="dataClear('new');dataObj.params.mode='detail';saveButtonName='저장'" class="btn btn-xs btn-outline-info mb-3 float-right" style="width:max-content;" variant="outline-primary">
            신규등록
          </b-button>
            <vc-calendar
                v-model="today"
                :attributes="attributes"
                @dayclick="selectedDay"
            />
        </div>
        <div class="d-flex flex-column" style="width:calc(100% - 400px);">
          <div class="instrument-calendar float-right card card-default" v-for="(data) in curMomentDayList"  :key="data.hdyseq"  style="background-color:#fff;">
            <div>
              <div class="h4 float-left">
                {{data.title}}
                <b-button @click="clickedDeleteMomentDay(data)" class="btn btn-outline-danger ml-2" variant="danger-primary">삭제</b-button>
              </div>
              <div class="h4 float-right">{{data.year}}년 {{data.month}}월{{data.day}}일 (음력 : {{data.lunar.year}}년 {{data.lunar.month}}월{{data.lunar.day}}일)</div>
              <table class="table table-striped table-bordered">
                  <colgroup>
                      <col width="15%" class="bg-lightdark"/>
                      <col width="50%"/>
                      <col width="25%" class="bg-lightdark"/>
                      <col width="10%"/>
                  </colgroup>
                  <thead>
                      <tr class="text-center">
                          <td>노출 순서</td>
                          <td>제목</td>
                          <td>등록일 / 수정일</td>
                          <td>삭제</td>
                      </tr>
                  </thead>
                  <tbody>
                    <tr v-if="data.momentContList.length == 0 || data.momentContList.length == null ">
                      <td colspan="3" class="text-center">No matching records</td>
                    </tr>
                    <tr v-else v-for="(item, index) in data.momentContList"  :key="`momentCont_${index}`" >
                        <td class="text-center d-flex">
                            <b-button @click="orderNumUp(data.momentContList,index)" :disabled="index==0" 
                              :style="index==0 ? 'color:#eee' : 'color:#000'">
                              ▲</b-button>
                            <b-button @click="orderNumDown(data.momentContList,index)" :disabled="index==data.momentContList.length-1"
                              :style="index==data.momentContList.length-1 ? 'color:#eee' : 'color:#000'">
                              ▼</b-button>
                        </td>
                        <td @click="getUsingFiles(item.contSeq, atrbInfo);setDetailInfo(item,data);saveButtonName='수정';dataObj.params.mode='detail';">
                            {{item.title}}({{getSchoolDisplay(item)}})
                        </td>
                        <td class="text-center">
                            <span>{{item.regDt != null ? item.regDt.substr(0,10) : ''}}/</span>
                            <span>{{item.updDt != null ? item.updDt.substr(0,10) : ''}}</span>
                        </td>
                        <td class="text-center">
                          <b-button @click="clickedDeleteMomentCont(data, item)" class="btn btn-outline-danger" variant="danger-primary">삭제</b-button>
                        </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
      </div>

      <!-- 상세 -->
      <div class="instrument-detail" v-show="dataObj.params.mode=='detail'">
        <div class="instrument-info card card-default"  style="width: 98%; margin: 0 auto;">
          <div class="instrument-title text-bold ml-3 mt-3 pb-2 border-bottom">계기자료 내용 보기</div>
          <div class="d-flex justify-content-around mt-3 pb-3 border-bottom" style="width: 98%; margin: 0 auto;">
            <div class="d-flex justify-content-start " style="width:40%;margin:0 1%;">
              <label class="mr-2">기념일</label>
              <input type="text" v-model="info.title" class="form-control" style="width:calc(100% - 80px);">
            </div>
            <div class="d-flex justify-content-start position-relative " style="width:56%;margin:0 1%;">
              <div class="d-flex justify-content-start" style="width: max-content;;margin:0 1%;">
                <template>
                  <label v-show="info.lunarYn=='N'" class="mr-2" style="width:30px">날짜</label>
                  <b-form-select v-show="info.lunarYn=='N'" v-model="info.year" @change="changedSolar();" :options="yearOption" class="custom-select custom-select-sm" style="width:100px"></b-form-select>
                  <b-form-select v-show="info.lunarYn=='N'" v-model="info.month" @change="changedMonth(info.month);changedSolar();" :options="monthOption" class="custom-select custom-select-sm" style="width:100px"></b-form-select>
                  <b-form-select v-show="info.lunarYn=='N'" v-model="info.day" @change="changedSolar();" :options="dayOption" class="custom-select custom-select-sm" style="width:100px"></b-form-select>
                </template>
                
                <template>
                  <label v-show="info.lunarYn=='Y'" class="mr-2 ml-2" style="width:60px">음력 날짜</label>
                  <b-form-select v-show="info.lunarYn=='Y'" v-model="info.lunar.year" @change="changedLunar();" :options="yearOption" class="custom-select custom-select-sm" style="width:100px"></b-form-select>
                  <b-form-select v-show="info.lunarYn=='Y'" v-model="info.lunar.month" @change="changedMonth(info.lunar.month, true);changedLunar();" :options="monthOption" class="custom-select custom-select-sm" style="width:100px"></b-form-select>
                  <b-form-select v-show="info.lunarYn=='Y'" v-model="info.lunar.day" @change="changedLunar();" :options="lunarDayOption" class="custom-select custom-select-sm" style="width:100px"></b-form-select>
                </template>
              </div>
              <div class="d-flex justify-content-start align-items-center" style="width:calc(48% - 120px);margin:0 1%;">
                <input type="checkbox" v-model="info.lunarYn" class="form-control mb-2 mr-1" id="lunarN" style="width:15px" true-value="N" false-value="Y">
                <label class="mr-3" for="lunarN">양력</label>
                <input type="checkbox" v-model="info.lunarYn" class="form-control mb-2 mr-1" id="lunarY" style="width:15px" true-value="Y" false-value="N">
                <label class="mr-3" for="lunarY">음력</label>
              </div>
              <b-btn @click="popupShowDepth5=true;" class="btn btn-primary position-absolute" style="padding: 2px 10px;right:0;top: -5px;">기존 기념일<br> 불러오기</b-btn>
            </div>
          </div>
          <div class="d-flex justify-content-around mt-3 pb-3 border-bottom" style="width: 98%; margin: 0 auto;">
            <div class="d-flex justify-content-start" style="width:40%;margin:0 1%;">
              <label class="mr-2">활동 제목</label>
              <input type="text" v-model=" info.momentContList.title" class="form-control " style="width:calc(100% - 80px);">
            </div>
            <div class="d-flex justify-content-start position-relative" style="width:56%;margin:0 1%;">
              <div class="d-flex justify-content-start" style="width:calc(48% - 50px);margin:0 1%;">
                <input type="checkbox" v-model="info.momentContList.schlEChkYn" class="form-control mb-2 mr-1" name="school" style="width:15px" true-value="Y" false-value="N">
                <label class="mr-3" style="line-height: 35px;">초등</label>
                <input type="checkbox" v-model="info.momentContList.schlMChkYn" class="form-control mb-2 mr-1" name="school" style="width:15px" true-value="Y" false-value="N">
                <label class="mr-3" style="line-height: 35px;">중등</label>
                <input type="checkbox" v-model="info.momentContList.schlHChkYn" class="form-control mb-2 mr-1" name="school" style="width:15px" true-value="Y" false-value="N">
                <label class="mr-3" style="line-height: 35px;">고등</label>
              </div>
            </div>
          </div>
          <div class="footer mt-2 mb-2">
            <div class="float-right">
                <b-button @click="save(info, info.momentContList,saveButtonName)" class="btn btn-b btn-info mr-2" variant="info mr-2">{{saveButtonName}}</b-button>
                <b-button @click="dataClear('list');isShowfiles = false;" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">목록</b-button>
            </div>
          </div>
        </div>
        <div class="instrument-info card card-default book-file" style="width: 98%; margin: 30px auto 0;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="instrument-title text-bold ml-3 mt-3 pb-2" style="width:max-content;">개체</div>
              <div v-show="info.momentContList.contSeq">
                <b-button @click="popupShowDepth1 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">개체등록</b-button>
                <b-button @click="popupShowDepth2 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">개체연결</b-button>
                <b-button @click="popupShowDepth4 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">온라인콘텐츠연결</b-button>
                <b-button @click="popupShowDepth3 = true" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">용도변경</b-button>
                <b-button v-show="!isShowfiles"  @click="clickChangeData('file'); isShowfiles = true;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">편집</b-button>
                <b-button v-show="isShowfiles" @click="resetOrderNum('file'); isShowfiles = false; editContSeq=0;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">취소</b-button>
                <b-button v-show="isShowfiles" @click="saveChangeOrder('file'); isShowfiles = false;" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2" >저장</b-button>
              </div>
            </div>
            <table class="table table-striped table-hover">
              <tbody class="div_scroll">
                <tr v-show="atrbInfo.files.length == 0 || atrbInfo.files.length == null  " class="text-center">
                  <td>No matching records</td>
                </tr>
                <draggable v-model="atrbInfo.files" :options="{group:'files', disabled:!isShowfiles}" @change="changeOrder(atrbInfo.files);checkColor(atrbInfo.files);">
                  <tr v-for="(item,index) in atrbInfo.files"  :key="`file_${index}`">
                    <b-btn class="btn btn-xs mr-2 btn-down" v-show="editContSeq!=item.fileSeq" @click="popupShowFile = false; downloadAs(item.fileDivCd,item.url,item.orgFileNm)" />
                    <em class="fa fa-edit fa-pull-right mr-2" style="margin-top: 1.25em;" @click="editAttr(item.fileSeq)" v-if="isShowfiles" v-show="editContSeq!=item.fileSeq "></em>
                    <td class="file" scope="row" @mousemove="findFile(item.fileSeq);" @click="mappingSeq = item.mappingSeq;popupFile(atrbInfo.fileSeq ,item.fileSeq)">
                      <a variant="outline-info mr-2" v-show="editContSeq!=item.fileSeq"  >{{ item.dispFileNm }}</a>
                        <b-input-group v-show="editContSeq==item.fileSeq" @click="atrbInfo.fileSeq = 0;">
                          <b-form-input type="text" v-model="item.dispFileNm"></b-form-input>
                          <b-input-group-append>
                            <b-btn class="btn btn-xs mr-2" variant="warning" @click="popupShowFile = false;deleteAttr(info.momentContList.contSeq,item.mappingSeq, atrbInfo);">Delete</b-btn>
                            <b-btn class="btn btn-xs mr-2" variant="info" @click="saveAttrFile(item.dispFileNm, item.pcontSeq, item );">Save</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      <div class="file-kind-wrap">
                        <div class="file_kind" v-show="editContSeq!=item.fileSeq">
                          <span v-show="item.purpTypeCd != null" :style="{color: contColor[index]}">{{contKind[index]}}</span>
                          <span v-show="item.teacherUseYn == 'Y'" :style="{color: item.teacherUseYn == 'Y' ? '#FF0000' : '' }">교사</span>
                          <span v-show="item.tutorUseYn == 'Y'" :style="{color: item.tutorUseYn == 'Y' ? '#708090' : '' }">강사</span>
                          <span v-show="item.studentUseYn == 'Y'" :style="{color: item.studentUseYn == 'Y' ? '#800000' : '' }">학생</span>
                        </div>
                        <div class="file_kind" v-show="editContSeq!=item.fileSeq">
                          <span v-show="item.fileTypeCd == '211006'">(온라인 콘텐츠)</span>
                          <span v-show="item.fileTypeCd == '211005'">(웹콘텐츠)</span>
                          <span v-show="item.fileTypeCd == '211004'">(웹콘텐츠링크)</span>
                          <span v-show="item.ext != null">({{item.ext}})</span>
                          <span v-show="item.playStartTime != null && item.playEndTime != null">({{item.playStartTime}} ~ {{item.playEndTime}})</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </draggable>
              </tbody>
            </table>
        </div>
      </div>
    </div>
    <b-modal id="fileRegModal" size="xl" title="개체등록" v-model="popupShowDepth1" hide-footer>
      <CsFileUploadPage :contSeq="info.momentContList.contSeq" :orgContSeq="info.momentContList.contSeq" :atrbInfo="atrbInfo"  @modal-state="popupClose" @get-data="refresh" :saveType="'ins'" />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="usingModalFiles" size="xl" title="개체용도변경" v-model="popupShowDepth3" hide-footer>
      <InMomentFileUsing :filedata="atrbInfo.files" :contSeq="info.momentContList.contSeq" :title="info.title" :isShow="isShow" @refresh="refresh" @modal-state="popupClose" />
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalFiles" size="xl" title="개체연결" v-model="popupShowDepth2" hide-footer>
      <InMomentFiles :contSeq="info.momentContList.contSeq" @modal-state="popupClose" @refresh="refresh" :saveType="'ins'"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="uploadModalFiles" size="xl" title="온라인콘텐츠연결" v-model="popupShowDepth4" hide-footer>
      <InMomentFilesOnline :contSeq="info.momentContList.contSeq" @modal-state="popupClose" @refresh="refresh" :saveType="'moment'"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="fileModal" size="xl" title="개체정보" v-model="popupShowFile" hide-footer>
      <CsFilePageInfo :fileSeq="atrbInfo.fileSeq" :contSeq="info.momentContList.contSeq" :mappingSeq = mappingSeq :isShow="isShow" @modal-state="popupClose" @refresh="refresh" :parentType="'txt'" :saveType="'ins'"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal>
    <b-modal id="anniversary" size="s" title="기존 기념일" v-model="popupShowDepth5" hide-footer>
      <InstrumentAnniversary :monthdata="info.month" :yeardata="info.year" @set-Anniversary="setAnniversary" @closePopup="popupClose"/>
      <loading :active="modalLoading" :is-full-page="true"/>
    </b-modal> 
   </ContentWrapper>
</template>

<script>
import Vue from 'vue';
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api';
import {setMomentdayList, setMomentdayListOrderNum, getMomentdayList, deleteMomentDay} from "@/api/exhibit/moment/MomentdayApi";
import {getCsFileList, getCsFileListByMapp, saveCsFile,getCsFileListByMomentMapp} from "@/api/cs/CsFileApi";
import {getCsContList, getCsContTreeList, getCsContItem, saveCsCont, deleteCsCont, saveCsContList,saveCsContExcel, deleteCsContByOrgContSeq} from "@/api/cs/CsContApi";
import {getMomentContItem,getMomentContList,saveMomentCont, deleteMomentCont} from "@/api/exhibit/moment/MomentApi";
import {getMomentFileMappingList, getMomentFileMappingItem, saveMomentFileMapping, saveMomentFileMappingList, deleteMomentFileMapping} from "@/api/exhibit/moment/MomentMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject,purpTypeCd, fileTypeCd, fileDivCdMap, aws_cdn_path, monthOption, day30 , day29,day31} from "@/utils/Constants";
import VCalendar from 'v-calendar';
import holidayKr from 'holiday-kr';
import InstrumentAnniversary from "../exhibit/popup/InstrumentAnniversary"
import InMomentFiles from "../exhibit/popup/InMomentFiles"
import InMomentFilesOnline from "../exhibit/popup/InMomentFilesOnline"
import CsFileUploadPage from "../cs/CsFileUploadPage"
import InMomentFileUsing from "../exhibit/popup/InMomentFileUsing"
import CsTextBookFiles from "../cs/CsTextBookFiles"
import CsFilePageInfo from "../cs/CsFilePageInfo"
import swal from 'sweetalert2'
import moment from 'moment';
import Axios from 'axios';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'

Vue.use(VCalendar, {
    componentPrefix: 'vc'
});

export default {
  components: {Pagenation,VCalendar,CsFileUploadPage, InstrumentAnniversary,InMomentFiles,InMomentFilesOnline,InMomentFileUsing ,CsFilePageInfo,draggable,Loading},
  setup() {
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const dataObj = reactive(_dataObject); //cloneDeep 객체복사 
     
    const totMomentDayList = ref(); //reactive 반응형 

    const colorpicker = ["red","yellow","blue","green"];

    const isShowfiles = false;
    const isShow = false;
    const mappingSeq = 0;

    const popupShowDepth1 = ref(false); //개체등록
    const popupShowDepth2 = ref(false); //개체연결
    const popupShowDepth3 = ref(false); //개체용도변경
    const popupShowDepth4 = ref(false); //온라인콘텐츠
    const popupShowDepth5 = ref(false); //기념일 팝업
    const popupShowFile = ref(false); //개체정보

    const today = reactive(new Date());

    const selectMonth = ref(today.getMonth()+1);
    const selectYear = ref(today.getFullYear());
    const selectday = ref();

    const dayOption = ref();
    const lunarDayOption = ref();
    const yearOption = ref([]);

    const contKind = ref([]);
    const contColor = ref([]);

    const tempData = []; //변경될 값 
    const changeData = []; //취소될 값 

    const saveButtonName = ref('저장');

    const atrbInfo = reactive({
      files:[],  // 개체
      fileSeq:'',
    })

    const info = reactive({
        title : '',
        lunarYn : 'N',
        year : today.getFullYear(),
        month : '',
        day : '1',
        hdaySeq : null,
        lunar : {
          date : '',
          year:'',
          month:'',
          day:'',
        },
        momentContList :{
          title:'',
          contSeq : '',
          hdaySeq : '',
          schlEChkYn : '',
          schlMChkYn : '',
          schlHChkYn : '',
        },
    });

    const curMomentDayList = ref([
    ]);

    const loadData = async () => {
      let result = await getMomentdayList();
      result.data.forEach((item) => {
        item.lunar = {};
        item.lunar.date = item.lunarDisplayDate;
        const date = moment(item.lunarDisplayDate);
        item.lunar.year = date.year();
        item.lunar.month = date.month() + 1;
        item.lunar.day = date.date();
        if (item.month == 6 && item.day == 8) {
          console.log("June item:", item);
        }
      });
      totMomentDayList.value = result.data;
      setDataDot(totMomentDayList);
      makeYearOption();
    }

    const makeYearOption = () => {
      const maxYear = new Date().getFullYear() + 5;
      for(var i = 2022;i < maxYear;i++){
        yearOption.value.push({
          value : i,
          text : (i).toString() + '년'
        });
      }
    }

    const attributes = ref([
      // {
      //   dot: true,
      //   dates: [
      //     new Date(2018, 0, 1), // Jan 1st
      //     new Date(2018, 0, 10), // Jan 10th
      //     new Date(2018, 0, 22), // Jan 22nd
      //   ],
      // },
      // {
      //   dot: 'red',
      //   dates: [
      //     new Date(2018, 0, 4), // Jan 4th
      //     new Date(2018, 0, 10), // Jan 10th
      //     new Date(2018, 0, 15), // Jan 15th
      //   ],
      // },
      // {
      //   dot: {
      //     style: {
      //       'background-color': 'brown',
      //     },
      //   },
      //   dates: [
      //     new Date(2018, 0, 12), // Jan 12th
      //     new Date(2018, 0, 26), // Jan 26th
      //     new Date(2018, 0, 15), // Jan 15th
      //   ],
      // },
    ]);

    const checkedDepthFiles = (type) => {
      if(type == '5'){
        if(atrbInfo.files.length == 0 ){
          alert("용도변경할 개체가 없습니다.");
          return false;
        }
        else{
          return true;
        }
      }
      else{
        if(checkedDepth1.length == 0){
          alert("개체 등록을 위한 단원 선택해주세요.");
          return false;
        }
        else{
          return true;
        }
      }
    }

    const setDataDot = (_data) =>{
      attributes.value = [];
      let red =[];
      let yellow =[];
      let blue =[];
      let green =[];
      let num = 0;

      totMomentDayList.value = _.cloneDeep(_data.value);

      _data.value.map((row,i)=>{
        if(num == 0){
          red.push(new Date(row.year,row.month-1,row.day))
          num++;
        }else if(num==1){
          yellow.push(new Date(row.year,row.month-1,row.day))
          num++;
        }else if(num==2){
          blue.push(new Date(row.year,row.month-1,row.day))
          num++
        }else if(num==3){
          green.push(new Date(row.year,row.month-1,row.day))
          num=0;
        }
      });
      colorpicker.map((row,i)=>{
        let params = {};
        
        if(i==1){
          params = {
            dot : colorpicker[0],
            dates: red,
          }
        }
        else if(i==2){
          params = {
            dot : colorpicker[1],
            dates: yellow,
          }
        }
        else if(i==3){
          params = {
            dot : colorpicker[2],
            dates: blue,
          }
        }
        else{
          params = {
            dot : colorpicker[3],
            dates: green,
          }
        }
        attributes.value.push(params);
      });
    }

    const selectedDay = (day) =>{
      curMomentDayList.value = [];

      totMomentDayList.value.filter((v) => {
        let momentDay = _.cloneDeep(info);
        momentDay.title = "기념일 없음";
        if(v.year == day.year && v.month == day.month && v.day == day.day) {
          if(v.momentContList != null){
            momentDay.momentContList = v.momentContList;
            momentDay.momentContList.sort(function(a,b){
              return a.orderNum - b.orderNum;
            })
          }
          momentDay.title = v.title;
          momentDay.lunarYn = v.lunarYn;
          momentDay.year = day.year;
          momentDay.month = day.month;
          momentDay.day = day.day;
          momentDay.lunar.year = v.lunar.year;
          momentDay.lunar.month = v.lunar.month;
          momentDay.lunar.day = v.lunar.day;
          momentDay.lunar.date = `${v.lunar.year}-${v.lunar.month}-${v.lunar.day}`;

          momentDay.hdaySeq = v.hdaySeq;
          curMomentDayList.value.push(momentDay);
        }
      });
    }
    
    const dataClear = (type) =>{
      info.title = '';
      info.lunarYn = 'N';
      info.year = today.getFullYear();
      info.month = today.getMonth()+1;;
      info.day = 1;
      info.hdaySeq = '';
      info.momentContList.contSeq = '';
      info.momentContList.hdaySeq = '';
      info.momentContList.schlEChkYn = '';
      info.momentContList.schlHChkYn = '';
      info.momentContList.schlMChkYn = '';
      info.momentContList.title = '';
      info.momentContList.length = 0;
      info.lunar = holidayKr.getLunar(info.year, info.month, info.day);

      changedMonth(info.month.toString());
      changedMonth(info.lunar.month.toString(), true);

      atrbInfo.files = [];
      saveButtonName.value = '저장';
      dataObj.params.mode='list';
    }
    
    const orderNumUp = (momentContList,index) =>{
      if(index != 0){
        const order = momentContList[index].orderNum;
        const upOrder = momentContList[index-1].orderNum;
        momentContList[index].orderNum = upOrder;
        momentContList[index-1].orderNum = order;

        const params = momentContList.filter((row, i) => i == index || i == index-1)
          .map(row => {
            return {
              contSeq: row.contSeq,
              orderNum: row.orderNum,
            }
          });
        setMomentdayListOrderNum(params); 
        momentContList.sort(function(a,b){
          return a.orderNum - b.orderNum;
        }) 
      }
    }
    
    const orderNumDown = (momentContList,index) =>{
      if(momentContList.length-1 != index){
        const order = momentContList[index].orderNum;
        const downOrder = momentContList[index+1].orderNum;
        momentContList[index].orderNum = downOrder;
        momentContList[index+1].orderNum = order;

        const params = momentContList.filter((row, i) => i == index || i == index+1)
          .map(row => {
            return {
              contSeq: row.contSeq,
              orderNum: row.orderNum,
            }
          });
        setMomentdayListOrderNum(params);
        momentContList.sort(function(a,b){
          return a.orderNum - b.orderNum;
        }) 
      }
    }

    const popupClose = (version) =>{ //b-modal 팝업 닫는 함수
      if(version == "addfile"){
        popupShowDepth1.value = false;
        
      }else if(version == "2"){
        popupShowDepth2.value = false;
      }
      else if(version == '3'){
        popupShowDepth3.value = false;
      }
      else if(version == '4'){
        popupShowDepth4.value = false;
      }
      else if(version == '5'){
        popupShowDepth5.value = false;
      }else if(version =='info'){
        popupShowFile.value=false;
      }
    }

    const setDetailInfo = (item,data) => {
      
        info.hdaySeq = data.hdaySeq;
        info.title = data.title;
        info.lunarYn = data.lunarYn;
        info.year = data.year;
        info.month = data.month;
        info.day = data.day;
        info.lunar.date = data.lunar.date;
        info.lunar.year = data.lunar.year;
        info.lunar.month = data.lunar.month;
        info.lunar.day = data.lunar.day;
        info.momentContList.title = item.title;
        info.momentContList.contSeq = item.contSeq;
        info.momentContList.hdaySeq = item.hdaySeq;
        info.momentContList.schlEChkYn = item.schlEChkYn;
        info.momentContList.schlMChkYn = item.schlMChkYn;
        info.momentContList.schlHChkYn = item.schlHChkYn;

        //console.log('detailInfo momentContList:', info.momentContList);

        changedMonth(info.month.toString());
        changedMonth(info.lunar.month.toString(), true);
    }

    const changedMonth = (value, isLunar) => {
      console.log('changedMonth:', value);
      if (isLunar) {
        const lunarDays = {
          '1':day30, '2':day30, '3':day30, '4':day30, '5':day30, '6':day30,
          '7':day30, '8':day30, '9':day30, '10':day30, '11':day30, '12':day30,
        };
        lunarDayOption.value = lunarDays[value.toString()];
      } else {
        const solarDays = {
          '1':day31, '2':day29, '3':day31, '4':day30, '5':day31, '6':day30,
          '7':day31, '8':day31, '9':day30, '10':day31, '11':day30, '12':day31,
        };
        dayOption.value = solarDays[value];
      }
    }

    const changedSolar = () => {
      info.lunar = holidayKr.getLunar(info.year, info.month, info.day);
    }

    const changedLunar = () => {
      const solarObj = holidayKr.getSolar(info.lunar.year, info.lunar.month, info.lunar.day);
      info.year = solarObj.year;
      info.month = solarObj.month;
      info.day = solarObj.day;
    }

    const checkColor = (data) =>{
      data.forEach((row, i) =>{
        switch(row.purpTypeCd){
          case '209001' : 
          contKind.value[i]='수업용1';
          contColor.value[i]="#008000";
          break;

          case '209002' :
          contKind.value[i]='수업용2';
          contColor.value[i]="#0000FF";
          break;

          case '209003' : 
          contKind.value[i]='과제용';
          contColor.value[i]="#800080";
          break;

          case '209004' :
          contKind.value[i]='평가용';
          contColor.value[i]="#FF8C00";
          break;

          case '209005' : 
          contKind.value[i]='연구용';
          contColor.value[i]="#FF00FF";
          break;
        }
      });
    };

    const setAnniversary = (item) => { //기념일 선택 팝업에서 갖고온 데이터 적용
       info.year = item.year;
       info.month = item.month;
       info.day = item.day;
       info.lunar.date = item.lunar.date;
       info.lunar.year = item.lunar.year;
       info.lunar.month = item.lunar.month;
       info.lunar.day = item.lunar.day;
       info.lunarYn = item.lunarYn;
       info.title = item.title;
       info.hdaySeq = item.hdaySeq;
       info.momentContList.contSeq = '';
       info.momentContList.hdaySeq = '';
       info.momentContList.schlEChkYn = '';
       info.momentContList.schlHChkYn = '';
       info.momentContList.schlMChkYn = '';
       info.momentContList.title = '';
       info.momentContList.length = 0;
       atrbInfo.files = [];
              
       popupShowDepth5.value=false;
    }

    const refresh = async(item) =>{
      let param = await{
        contSeq : item.contSeq,
      }
      let result = await getCsFileListByMomentMapp(param);

      if(result.data.length > 0){
        atrbInfo.files = result.data;
        checkColor(atrbInfo.files);
      }

      if(item.version == "2"){
        popupShowDepth2.value = false;
      }
      else if(item.version == '3'){ //용도변경
        popupShowDepth3.value = false;
      }
      else if(item.version == '4'){
        popupShowDepth4.value = false;
      }
      else if(item.version == 'addfile'){
        popupShowDepth1.value = false;
      }
      else if(item.version == 'info'){
        popupShowFile.value = false;
      }
    }

    const popupFile = (editContSeq,fileSeq) =>{
      if(editContSeq == fileSeq){
        popupShowFile.value = true;
      }else{
        popupShowFile.value = false;
      }
    }

    const getSchoolDisplay = (item) => {
      let schoolGrades = [];
      if (item.schlEChkYn == 'Y') {
        schoolGrades.push('초');
      }
      if (item.schlMChkYn == 'Y') {
        schoolGrades.push('중');
      }
      if (item.schlHChkYn == 'Y') {
        schoolGrades.push('고');
      }

      return schoolGrades.length == 0 ? '학교정보 없음' : schoolGrades.join(',');
    }

    onMounted(loadData)
    return {
        isShow,
        isShowfiles,
        info,
        totMomentDayList,
        curMomentDayList,
        atrbInfo,
        today,
        dataObj,
        colorpicker,
        attributes,
        setDataDot,
        setDetailInfo,
        selectedDay,
        popupShowDepth1,
        popupShowDepth2,
        popupShowDepth3,
        popupShowDepth4,
        popupShowDepth5,
        popupShowFile,
        selectMonth,
        selectday,
        dayOption,
        lunarDayOption,
        orderNumUp,
        orderNumDown,
        monthOption, 
        selectYear,
        yearOption,
        day30 , 
        day31,
        contKind,
        contColor,
        dataClear,
        modalLoading: false,
        changedMonth,
        changedSolar,
        changedLunar,
        saveButtonName,
        checkedDepthFiles,
        popupClose,
        setAnniversary,
        checkColor,
        editContSeq:0,
        mappingSeq,
        tempData,
        changeData,
        refresh,
        popupFile,
        getSchoolDisplay,
        ...methods(),
    }
  },
}

function methods() {
  var context = {};
  context["getMomentdayList"] = getMomentdayList;  // get list
  context["setMomentdayList"] = setMomentdayList;  // set list
  context["setMomentdayListOrderNum"] = setMomentdayListOrderNum;  // set list OrderNum
  context["getMomentFileMappingList"] = getMomentFileMappingList;  // set list OrderNum
  context["getMomentFileMappingItem"] = getMomentFileMappingItem;  // set list OrderNum
  context["saveMomentFileMapping"] = saveMomentFileMapping;  // set list OrderNum
  context["saveMomentFileMappingList"] = saveMomentFileMappingList;  // set list OrderNum
  context["saveMomentCont"] = saveMomentCont;  // set list OrderNum
  context["deleteMomentFileMapping"] = deleteMomentFileMapping;  // set list OrderNum
  context["saveCsCont"] = saveCsCont;  // set list OrderNum
  context["getCsFileListByMomentMapp"] = getCsFileListByMomentMapp;  // set list OrderNum  
  context["saveCsFile"] = saveCsFile;  // set list OrderNum

  async function save(dayItem, inputItem, saveButtonName){  //saveButtonName = '저장' , '수정'
    if (!confirm("내용을 " + saveButtonName + '하시겠습니까?' )) {
      // 취소(아니오) 버튼 클릭 시 이벤트
      return false;
    } 
    // 확인(예) 버튼 클릭 시 이벤트
    let lunarYn = dayItem.lunarYn == null ? "N" : dayItem.lunarYn;
    let schlEChkYn = inputItem.schlEChkYn == null ? "N" : inputItem.schlEChkYn;
    let schlMChkYn = inputItem.schlMChkYn == null ? "N" : inputItem.schlMChkYn;
    let schlHChkYn = inputItem.schlHChkYn == null ? "N" : inputItem.schlHChkYn;

    let params = {
      title : dayItem.title,
      lunarYn : lunarYn,
      year : dayItem.year,
      month : dayItem.month,
      day : Number(dayItem.day)
    };
    if (dayItem.hdaySeq) {
      params.hdaySeq = dayItem.hdaySeq
    }
    console.log('save:params:', params);
    const setResult = await setMomentdayList(params);

    let MomentParams = { 
      title: inputItem.title,
      hdaySeq : setResult.data,
      schlEChkYn : schlEChkYn,
      schlMChkYn : schlMChkYn,
      schlHChkYn : schlHChkYn,
    };
    if (inputItem.contSeq) {
      MomentParams.contSeq = inputItem.contSeq;
    }
    const resultMoment = await saveMomentCont(MomentParams);
    if(resultMoment.message == "정상적으로 처리되었습니다."){
      alert(saveButtonName+"이 완료되었습니다.");
      if (!inputItem.contSeq) {
        inputItem.contSeq = resultMoment.data;
      }
      await this.refreshList(params);
    } else {
      alert(saveButtonName+"이 실패되었습니다.");
    }
  }

  async function refreshList(params) {
    const result = await getMomentdayList();
    result.data.forEach((item) => {
      item.lunar = {};
      item.lunar.date = item.lunarDisplayDate;
      const date = moment(item.lunarDisplayDate);
      item.lunar.year = date.year();
      item.lunar.month = date.month() + 1;
      item.lunar.day = date.date();
    });
    this.totMomentDayList.value = result.data;
    this.setDataDot(this.totMomentDayList);
    this.selectedDay(params);
  }

  function editAttr(_contSeq) {
    this.editContSeq = this.editContSeq==_contSeq?0:_contSeq;
  }

  async function saveAttr(item_title, pcont_seq){
    console.log('## saveAttr',this.editContSeq)
    let params = {
      contSeq : this.editContSeq,
      title : item_title,
      pcontSeq: pcont_seq,
    }
    await saveCsCont(params);
    this.editContSeq=0;
  }

  async function getUsingFiles(_contSeq, _atrbInfo){
    let param = await{
      contSeq : _contSeq,
    }

    let result = await getCsFileListByMomentMapp(param);

    _atrbInfo.files = result.data;
    _atrbInfo.files.sort(function(a,b){
      return a.orderNum - b.orderNum;
    });
    this.checkColor(_atrbInfo.files);
  }

    //드래그 순서 변경 함수 
  function changeOrder(atrbInfo) {
     let _temp = []; // 최종 orderNum
     let _tempData = [];
      
      for(var i = 0; i < this.changeData.length; i++){
         _temp[i] = this.changeData[i].orderNum;
      }

      for(var i = 0; i< atrbInfo.length; i++){
        _tempData.push(atrbInfo[i]);
        _tempData[i].orderNum = _temp[i];
      }
  }


  async function deleteAttr(_contSeq,fileSeq, atrbInfo){
    if (!confirm("개체파일의 맵핑을 삭제하시겠습니까?")){
      return false;
    }else{
      let params = {
        mappingSeq : fileSeq,
      }
      let result = await deleteMomentFileMapping(params);
      if(result.data){
        alert('삭제되었습니다.');
        getUsingFiles(_contSeq, atrbInfo);
      }
    }
  }

  //드래그 순서 저장 함수 
  function saveChangeOrder(depth) {
    saveMomentFileMappingList(this.atrbInfo.files);
    this.atrbInfo.files.sort(function(a,b){
      return a.orderNum - b.orderNum;
    });
    this.changeData = _.cloneDeep(this.atrbInfo.files);
  }

  //드래그 순서 편집 함수 
  function clickChangeData(depth) {  
    this.changeData = _.cloneDeep(this.atrbInfo.files);
  }

  //드래그 순서 취소 함수 
  function resetOrderNum(depth) {  
    this.atrbInfo.files = _.cloneDeep(this.changeData);
  }

  async function findFile(fileSeq){
    this.atrbInfo.fileSeq = fileSeq
  }


  const downloadAs = (fileDivCd, url, name) => {
        let fullUrl = aws_cdn_path + url;
        Axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob"
      })
        .then(response => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(response.data);
          a.href = url;
          a.download = name;
          a.click();
        })
        .catch(err => {
          console.log("error", err);
        });
  };

  async function saveAttrFile(item_title, fileSeq,item){
    console.log('## saveAttrFile',this.editContSeq)
    item.dispFileNm = item_title;

    let result = await saveCsFile(item);
    if(result != null){
      alert("변경되었습니다.");
      this.editContSeq=0;
      this.isShowfiles = false;
    }
  }

  // 기념일 삭제
  async function clickedDeleteMomentDay(momentDay) {
    const title = momentDay.title;
    if (!confirm(`기념일 '${title}'와 모든 하위 활동들을 삭제하시겠습니까?`)) {
      return;
    }

    const hdaySeq = momentDay.hdaySeq;
    const result = await deleteMomentDay(hdaySeq);
    alert('삭제되었습니다.');
    const params = {
      year : momentDay.year,
      month : momentDay.month,
      day : momentDay.day
    };
    await this.refreshList(params);
  }

  // 기념일의 활동 삭제
  async function clickedDeleteMomentCont(momentDay, momentCont) {
    const title = momentCont.title;
    if (!confirm(`활동 '${title}'을 삭제하시겠습니까?`)) {
      return;
    }

    const contSeq = momentCont.contSeq;
    const result = await deleteMomentCont(contSeq);
    alert('삭제되었습니다.');
    const params = {
      year : momentDay.year,
      month : momentDay.month,
      day : momentDay.day
    };
    await this.refreshList(params);
  }

  return {save,saveAttr,deleteAttr,getUsingFiles,changeOrder,saveAttrFile,editAttr,
    downloadAs,clickChangeData,resetOrderNum,saveChangeOrder,findFile,
    clickedDeleteMomentDay, clickedDeleteMomentCont, refreshList,
  }
}

</script>
